import { Directive, ElementRef, HostListener } from '@angular/core';
import { ProjectUtils } from '../project-utils';

@Directive({
  selector: '[appTrimFirstLastSpace]',
  standalone: true,
})
export class TrimFirstLastSpaceDirective {
  constructor(private el: ElementRef) {}

  @HostListener('change') onChange() {
    this.el.nativeElement.value = ProjectUtils.capitalizeFirstName(
      this.el.nativeElement.value.trim()
    );
  }
}
